export const mesesEnum = [
    { name: 'Enero', value: 1, code: 'ENERO' },
    { name: 'Febrero', value: 2, code: 'FEBRERO' },
    { name: 'Marzo', value: 3, code: 'MARZO' },
    { name: 'Abril', value: 4, code: 'ABRIL' },
    { name: 'Mayo', value: 5, code: 'MAYO' },
    { name: 'Junio', value: 6, code: 'JUNIO' },
    { name: 'Julio', value: 7, code: 'JULIO' },
    { name: 'Agosto', value: 8, code: 'AGOSTO' },
    { name: 'Septiembre', value: 9, code: 'SEPTIEMBRE' },
    { name: 'Octubre', value: 10, code: 'OCTUBRE' },
    { name: 'Noviembre', value: 11, code: 'NOVIEMBRE' },
    { name: 'Diciembre', value: 12, code: 'DICIEMBRE' }
];

export const periodosEnum = [
    { name: 'Mensual', code: 'MENSUAL' },
    { name: 'Semanal', code: 'SEMANAL' },
    { name: 'Hoy', code: 'HOY' },
];